import React from "react";
import { SUBSTEP_TYPE, AUTO_FILLED_KEYS } from "utils/constants/onboarding";
import TextInput from "./TextInput";
import ImageInput from "./ImageInput";
import TodoList from "./TodoList";
import SpecialControl from "./registry/SpecialControl";
import { getSpecialForKey } from "./registry";
import styles from "../Form.module.scss";

// Registry (key-based) first, then substep_type fallback.
// substepKeyToId: optional { [key]: substep_id } map of siblings in the same step,
// used by SpecialControl for side-effect callbacks (e.g. city → state auto-fill).
function SubstepValue({ substep, value, onChange, error, allValues, allErrors, valueByKey, isReadOnly, substepKeyToId }) {
  if (!substep) return null;

  // Auto-filled keys are read-only in the UI — value is set programmatically.
  const effectiveReadOnly = isReadOnly || AUTO_FILLED_KEYS.has(substep?.key);
  const common = { substep, value, onChange, error, isReadOnly: effectiveReadOnly };

  const special = getSpecialForKey(substep?.key);

  // Registry entries with a Component → render via SpecialControl (handles options, hooks, etc.)
  if (special?.Component) {
    return (
      <SpecialControl
        special={special}
        substepKeyToId={substepKeyToId}
        onChange={onChange}
        hint={special.hint}
        {...common}
      />
    );
  }

  // Registry entries without a Component carry only extra props (e.g. allowedExtensions, hint).
  const extraProps = special ? (({ Component, useOptions, options, withStateAutoFill, ...rest }) => rest)(special) : {};

  switch (substep.substep_type) {
    case SUBSTEP_TYPE.TEXT_INPUT:
      return <TextInput {...common} {...extraProps} />;
    case SUBSTEP_TYPE.IMAGE_INPUT:
      return <ImageInput {...common} {...extraProps} />;
    case SUBSTEP_TYPE.TODO_LIST:
      return <TodoList {...common} allValues={allValues} allErrors={allErrors} valueByKey={valueByKey} />;
    default:
      return (
        <div className={styles.muted}>
          Unsupported field type: {substep.substep_type}
        </div>
      );
  }
}

export default SubstepValue;
